<section class="slack-content">
  <mode-dialog-loading-view *ngIf="slackAppDetails === null; else notLinked"></mode-dialog-loading-view>
  <ng-template #notLinked>
    <mode-slack-not-linked [owner]="owner" *ngIf="!slackAppDetails?.hasSlackApp; else slackApp"></mode-slack-not-linked>
  </ng-template>

  <ng-template class="slack-main" #slackApp>
    <form class="section slack-form" [formGroup]="slackForm">
      <mode-slack-channel-selector
        [slackChannelDetails]="{
          slackAppUrl: slackAppDetails?.slackAppUrl,
          slackAppTeamName: slackAppDetails?.slackAppTeamName,
          slackChannels: slackAppDetails?.slackChannels
        }"
        (setSlackChannel)="setSlackChannel($event)"
      ></mode-slack-channel-selector>

      <section class="message">
        <div class="form-field">
          <label class="mode-label" for="message"> Message </label>
          <textarea
            class="mode-textarea"
            id="message"
            data-test="slack-message"
            maxlength="500"
            formControlName="message"
            placeholder="Add a message (optional)"
          ></textarea>
        </div>
      </section>
    </form>
    <div mat-dialog-actions>
      <capra-button
        *ngIf="schedulingEnabled"
        class="delivery-button"
        data-test="schedule-delivery"
        text="Set up a delivery schedule"
        variant="secondary"
        color="neutral"
        (clicked)="scheduleDelivery.emit()"
      ></capra-button>
      <capra-button text="Cancel" variant="secondary" color="neutral" (clicked)="cancel.emit()"></capra-button>
      <capra-button
        text="Share"
        data-test="send-slack-message"
        (clicked)="sendMessage(slackForm.value)"
        [disabled]="!channelControl.valid"
      ></capra-button>
    </div>
  </ng-template>
</section>
